module.exports = __webpack_public_path__ + "static/img/1679716401637.5ddb06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1679716401637.png
// module id = Zv+x
// module chunks = 1